export enum TypesOfSpinner {
  viewSpinner = 'ThreeDSpinner',
  viewLayouts = 'GroupedPlacementPlanning',
  viewFloors = 'FloorPlanning',
  view2d = 'Crosstable',
  viewInMap = 'Map',
}
